import router from '../router';
import qs from 'qs';
import store from '../store';

export default class TalloAPIPlugin {
    static install(Vue, /*options*/) {
        Vue.prototype.$api = new Vue({
            data: function () {
                return {
                    user: null,
                    baseURI: process.env.VUE_APP_TALLO_API_URL,
                    opts: {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }
                }
            },

            methods: {
                getParameters() {
                    return this._get('/api/config');
                },

                login(user, pass) {
                    function isEmail(email) {
                        // TODO: Disabling this lint until i have time to read this regex and understand it
                        // eslint-disable-next-line
                        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        return re.test(String(email).toLowerCase());
                    }

                    let body = {
                        password: pass
                    };

                    if(isEmail(user)) {
                        body['email'] = user;
                    } else {
                        body['username'] = user;
                    }

                    return this._post("/api/auth/login", body);
                },

                logout() {
                    return this._post("/api/auth/logout", {});
                },

                authCheck() {
                    return this._get("/api/auth/check");
                },

                register(data) {
                    return this._post("/api/registration", data);
                },

                verifyRegistration(email, code) {
                    return this._post("/api/users/verify", {
                        email: email,
                        code: code
                    })
                },

                requestNewPassword(email) {
                    return this._post("/api/auth/forgot", {
                        email: email
                    });
                },

                setNewPassword(email, code, password) {
                    return this._post("/api/auth/reset_password", {
                       email: email,
                       code: code,
                       password: password
                    });
                },

                cartAdd(cart, product, quantity) {
                    return this._put('/api/carts/' + cart, {
                        product: product,
                        quantity: quantity
                    });
                },

                cartRemove(cart, product, quantity) {
                    return this._put('/api/carts/' + cart, {
                        product: product,
                        quantity: -quantity
                    });
                },

                cartPatch(cart, data) {
                    return this._patch('/api/carts/' + cart, data);
                },

                getUser(id) {
                    return this._get("/api/users/" + id);
                },

                setCustomerInfo(id, data) {
                    return this._patch("/api/customers/" + id, data);
                },

                getCustomerShippingAddresses(customerId) {
                    return this._get("/api/customers/" + customerId + "/shippingAddresses");
                },

                addCustomerShippingAddress(customerId, data) {
                    return this._post("/api/customers/" + customerId + "/shippingAddresses", data);
                },

                removeCustomerShippingAddress(customerId, id) {
                    return this._delete("/api/customers/" + customerId + "/shippingAddresses/" + id);
                },

                getCustomerBillingAddresses(customerId) {
                    return this._get("/api/customers/" + customerId + "/billingAddresses");
                },

                addCustomerBillingAddress(customerId, data) {
                    return this._post("/api/customers/" + customerId + "/billingAddresses", data);
                },

                removeCustomerBillingAddress(customerId, id) {
                    return this._delete("/api/customers/" + customerId + "/billingAddresses/" + id);
                },

                getDiscounts(addressId) {
                    return this._get("/api/discounts?cart=" + "me" + "&address=" + addressId);
                },

                getCustomerPaymentMethods(id) {
                    return this._get("/api/customers/" + id + "/paymentMethods");
                },

                getCategories() {
                    return this._get("/api/categories");
                },

                getProducts(categoryId) {
                    return this._get("/api/categories/" + categoryId);
                },

                getRecommendedProducts() {
                    return this._get("/api/products?recommended=true");
                },

                getZones() {
                    return this._get("/api/zones");
                },

                getZonesByLocation(location) {
                    return this._get("/api/zones?lng=" + location.lng + "&lat=" + location.lat);
                },

                getZoneSchedule(id) {
                    return this._get("/api/zones/" + id + "/schedules");
                },

                getZoneAvailableSchedule(id) {
                    return this._get("/api/zones/" + id + "/availableSchedules");
                },

                get(path, query) {
                    let queryString = qs.stringify(query, { encodeValuesOnly: true });
                    return this._get(path + '?' + queryString);
                },

                post(path, data) {
                    return this._post(path, data);
                },

                patch(path, data) {
                    return this._patch(path, data);
                },

                _get(path) {
                    const token = store.getters['user/getToken']();
                    if (token) {
                        this.opts.headers.Authorization = `Bearer ${token}`;
                    }

                    return this.$axios.get(this.baseURI + path, this.opts).then(response => {
                        if(Object.keys(response.data).length === 0)
                            return null;
                        return response.data;
                    }).catch(error => {
                        if(error.response && error.response.status === 401) {
                            store.dispatch('user/logout');
                            location.reload(true);
                        }
                        else if(error.response && error.response.data) {
                            if(error.response.data.code === 'error.authentication.required') {
                                router.push({ name: 'Login' });
                            }
                            else {
                                throw error.response.data;
                            }
                        }
                        else {
                            throw error;
                        }
                    });
                },

                _post(path, data) {
                    const token = store.getters['user/getToken']();
                    if (token) {
                        this.opts.headers.Authorization = `Bearer ${token}`;
                    }

                    return this.$axios.post(this.baseURI + path, data, this.opts).then(response => {
                        return response.data;
                    }).catch(error => {
                        if(error.response && error.response.status === 401) {
                            store.dispatch('user/logout');
                            location.reload(true);
                        }
                        else if(error.response && error.response.data) {
                            if(error.response.data.code === 'error.authentication.required') {
                                router.push({ name: 'Login' });
                            }
                            else {
                                throw error.response.data;
                            }
                        }
                        else {
                            throw error;
                        }
                    });
                },

                _patch(path, data) {
                    const token = store.getters['user/getToken']();
                    if (token) {
                        this.opts.headers.Authorization = `Bearer ${token}`;
                    }

                    return this.$axios.patch(this.baseURI + path, data, this.opts).then(response => {
                        return response.data;
                    }).catch(error => {
                        if(error.response && error.response.status === 401) {
                            store.dispatch('user/logout');
                            location.reload(true);
                        }
                        else if(error.response && error.response.data) {
                            if(error.response.data.code === 'error.authentication.required') {
                                router.push({ name: 'Login' });
                            }
                            else {
                                throw error.response.data;
                            }
                        }
                        else {
                            throw error;
                        }
                    });
                },

                _put(path, data) {
                    const token = store.getters['user/getToken']();
                    if (token) {
                        this.opts.headers.Authorization = `Bearer ${token}`;
                    }

                    return this.$axios.put(this.baseURI + path, data, this.opts).then(response => {
                        return response.data;
                    }).catch(error => {
                        if(error.response && error.response.status === 401) {
                            store.dispatch('user/logout');
                            location.reload(true);
                        }
                        else if(error.response && error.response.data) {
                            if(error.response.data.code === 'error.authentication.required' || error.response.data.code === 'error.authorization.rejected') {
                                router.push({ name: 'Login' });
                            }
                            else {
                                throw error.response.data;
                            }
                        }
                        else {
                            throw error;
                        }
                    });
                },

                _delete(path, data) {
                    const token = store.getters['user/getToken']();
                    if (token) {
                        this.opts.headers.Authorization = `Bearer ${token}`;
                    }

                    let config = {};
                    Object.assign(config, this.opts);
                    Object.assign(config, {
                        data: data
                    });

                    return this.$axios.delete(this.baseURI + path, config).then(response => {
                        return response.data;
                    }).catch(error => {
                        if(error.response && error.response.status === 401) {
                            store.dispatch('user/logout');
                            location.reload(true);
                        }
                        else if(error.response && error.response.data) {
                            if(error.response.data.code === 'error.authentication.required') {
                                router.push({ name: 'Login' });
                            }
                            else {
                                throw error.response.data;
                            }
                        }
                        else {
                            throw error;
                        }
                    })
                }
            }
        });
    }
}